export default __webpack_public_path__ + "static/media/screen4.4a177654.png";